import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { CONTENT_TYPES } from '@helpers/constants'
import Icon from '@components/Icon'
import { AppContext } from '@state/context'

const SearchInput = (props) => {
  const { handleSearchTermChange, handleTypeChange, hideContentTypeSelect } = props
  const [state] = useContext(AppContext)
  const [searchTerm, setSearchTerm] = useState(state?.search?.term)

  const contentOptions = [{
    label: 'Allt',
    value: 'all',
  }, {
    label: 'Böcker',
    value: CONTENT_TYPES.BOOK
  }, {
    label: 'Avsnitt',
    value: CONTENT_TYPES.SECTION
  }]

  return (
    <div
      className={`flex items-stretch border border-mediumGrey bg-lightGrey rounded`}
    >
      { !hideContentTypeSelect &&
        <select
          options={contentOptions}
          className={'bg-transparent outline-none border-none shadow-none'}
          onChange={(e) => handleTypeChange(e.target.value)}
          style={{
            ['--tw-ring-shadow']: 'none'
          }}
        >
          {contentOptions.map((option, index) =>
            <option key={index} value={option.value}>
              {option.label}
            </option>
          )}
        </select>
      }

      <input
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            handleSearchTermChange(searchTerm)
          }
        }}
        defaultValue={searchTerm}
        type={'text'}
        autoFocus
        className={'outline-none border-none shadow-none w-full' + (hideContentTypeSelect ? ' rounded' : '')}
        style={{
          ['--tw-ring-shadow']: 'none'
        }}
      />

      <button
        onClick={() => handleSearchTermChange(searchTerm)}
        type='button'
        className={'bg-primaryGreen rounded-r outline-none focus:outline-none px-6'}
      >
        <Icon
          icon={'Search'}
        />
      </button>
    </div>
  )
}

SearchInput.propTypes = {
  handleSearchTermChange: PropTypes.func,
  handleTypeChange: PropTypes.func,
}

export default SearchInput
